// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as StackFields from "../../resources/layout-and-structure/StackFields.res.js";
import * as CatalogVariant from "./CatalogVariant.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as CatalogVariantEditForm from "./CatalogVariantEditForm.res.js";

function CatalogVariantEditFormStockFieldsetPanel(props) {
  let match = CatalogVariantEditForm.useFormState().values;
  let bulk = match.bulk;
  let capacityUnit = match.capacityUnit;
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Stock"),
    description: I18n.t("Indicate the initial stock quantity of the reference or leave the stock at zero and create an order for the reception of the product."),
    children: [
      JsxRuntime.jsx(CatalogVariantEditForm.InputOptionalNumber.make, {
        field: "InitialStockQuantity",
        label: I18n.t("Initial stock"),
        placeholder: "0",
        appender: capacityUnit !== undefined && bulk ? ({
            TAG: "Custom",
            _0: capacityUnit
          }) : undefined,
        minValue: 0,
        precision: bulk ? CatalogVariant.defaultBulkCapacityPrecision : 0
      }),
      JsxRuntime.jsx(CatalogVariantEditForm.InputTextArea.make, {
        field: "InitialStockComment",
        label: I18n.t("Comment")
      }),
      bulk ? null : JsxRuntime.jsxs(StackFields.make, {
          children: [
            JsxRuntime.jsx(CatalogVariantEditForm.InputOptionalNumber.make, {
              field: "MaxStockThreshold",
              label: I18n.t("Maximum stock"),
              hideRequired: true,
              placeholder: "0",
              minValue: 0,
              precision: 0
            }),
            JsxRuntime.jsx(CatalogVariantEditForm.InputOptionalNumber.make, {
              field: "MinStockThreshold",
              label: I18n.t("Minimum stock"),
              hideRequired: true,
              placeholder: "0",
              minValue: 0,
              precision: 0
            }),
            JsxRuntime.jsx(CatalogVariantEditForm.InputOptionalNumber.make, {
              field: "StockOrderTriggerThreshold",
              label: I18n.t("Stock triggering the order"),
              hideRequired: true,
              placeholder: "0",
              minValue: 0,
              precision: 0
            })
          ]
        })
    ]
  });
}

let make = React.memo(CatalogVariantEditFormStockFieldsetPanel);

export {
  make,
}
/* make Not a pure module */
